"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseConfig = exports.consoleFormat = exports.changeProps = exports.maxLogLevel = exports.LogLevel = void 0;
const winston = __importStar(require("winston"));
const supports_color_1 = __importDefault(require("supports-color"));
// import rtracer from 'cls-rtracer';
const { format, format: { combine, printf }, transports, } = winston;
var LogLevel;
(function (LogLevel) {
    LogLevel["CRIT"] = "crit";
    LogLevel["ERROR"] = "error";
    LogLevel["WARN"] = "warn";
    LogLevel["INFO"] = "info";
    LogLevel["DEBUG"] = "debug";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
const maxLogLevel = () => {
    var _a;
    const envLvl = (_a = process.env.LOG_LEVEL) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    return (LogLevel[envLvl] ||
        (process.env.NODE_ENV === 'production' ? LogLevel.WARN : LogLevel.DEBUG));
};
exports.maxLogLevel = maxLogLevel;
const severityLevels = {
    [LogLevel.CRIT]: 0,
    [LogLevel.ERROR]: 1,
    [LogLevel.WARN]: 2,
    [LogLevel.INFO]: 3,
    [LogLevel.DEBUG]: 4,
};
const colorMap = {
    [LogLevel.CRIT]: '\x1b[35m',
    [LogLevel.ERROR]: '\x1b[31m',
    [LogLevel.WARN]: '\x1b[33m',
    [LogLevel.INFO]: '\x1b[32m',
    [LogLevel.DEBUG]: '\x1b[34m', // Blue
};
const colorEnd = '\x1b[0m';
const colorSupported = supports_color_1.default.stdout;
const changeProps = (logEvent) => {
    logEvent.color = colorMap[logEvent.level];
    if (typeof logEvent.message === 'object') {
        logEvent.message = JSON.stringify(logEvent.message);
    }
    logEvent.level = logEvent.level.toUpperCase();
    return logEvent;
};
exports.changeProps = changeProps;
const consoleFormat = ({ level, message, timestamp, color, metadata = {}, }) => {
    // const requestId = rtracer.id();
    const { stack } = metadata;
    const messageParts = [];
    messageParts.push(timestamp);
    // if (requestId) {
    //   messageParts.push(`RequestID: ${requestId}`);
    // }
    messageParts.push(`${level}\t`);
    messageParts.push(message);
    if (stack) {
        messageParts.push(`\n ${stack}`);
    }
    const formattedMessage = messageParts.join(' | ');
    if (colorSupported) {
        return `${color}${formattedMessage}${colorEnd}`;
    }
    return formattedMessage;
};
exports.consoleFormat = consoleFormat;
exports.baseConfig = {
    level: (0, exports.maxLogLevel)(),
    levels: severityLevels,
    format: combine(format(exports.changeProps)(), format.timestamp()),
    transports: [
        new transports.Console({
            format: printf(exports.consoleFormat),
            handleExceptions: true,
            stderrLevels: [LogLevel.CRIT, LogLevel.ERROR],
            silent: process.env.NODE_ENV === 'test',
        }),
    ],
    exitOnError: false,
};
